import { useState } from "react";
import { useEffect } from "react";
export const useAutofocusAfterClose = (open, openKeys, ref) => {
    const [wasOpen, setWasOpen] = useState(open);
    useEffect(() => {
        if (!openKeys.length && !open && wasOpen) {
            setWasOpen(false);
            ref.current.querySelector("[tabindex='0']").focus();
        }
        else {
            setWasOpen(true);
        }
    }, [open]);
};
